import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Spin, Carousel } from 'antd';
import WonderGameSlider from '../components/WonderGameSlider';
import Loader from '../components/Loader';
import GutenContent from '../components/GutenContent';
import Youtubeembed from '../components/Youtubeembed';


const OneonOneSession = () => {
    const [oosdata, setOosdata] = useState([])
    const [loading, setLoading] = useState(true)
    const [link, setLink] = useState("")


    useEffect(() => {
        getAboutdata()
    }, []);

    const getAboutdata = () => {
        axios.get('pages/376?acf_format=standard')
            .then((response) => {
                console.log(response.data)
                setOosdata(response.data)
                setLink(response.data.acf.buy_link_program)
                setLoading(false)
            })
    }

    const buyNow = () => {
        console.log(link)
        // navigate(link)
        window.location.href = link;
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        }, 700);

    }

    return (
        <div>
            {
                loading ? <Loader />
                    :
                    <>
                        {/* page heading */}
                        <div className='spacer'>
                            <p className='brand-text large-gradient-heading'>{oosdata.title.rendered}</p>
                        </div>

                        {/* program excerpt */}
                        <div className='spacer'>
                            {/* <p className='brand-text txt-survey'>{excerpt}</p> */}
                            <div className='html_text_block brand-text txt-survey' dangerouslySetInnerHTML={{ __html: oosdata.acf.short_excerpt_program }} />
                        </div>

                        {/* yt video embed */}
                        <div className='spacer'>
                            <Youtubeembed videourl={oosdata.acf.yt_video_url_program} />
                        </div>

                        {/* price and highlight section */}
                        <div className='grid grid-cols-2 gap-2 spacer'>
                            <div>
                                {/* price card */}
                                <div className='border-solid border-gray border-[1px] rounded p-2 h-full'>
                                    <div className='shiny-box'>
                                        <p className='border15px sub-heading brand-font h-1/3'>Program Price</p>

                                        <div className='flex flex-row test justify-between h-2/3 bottom7px'>
                                            <div className='flex flex-col justify-center'>
                                                <p className='brand-font text-left bottom15px'>₹</p>
                                            </div>
                                            <div className='flex flex-col justify-end'>
                                                <p className='brand-text leading-[50px] text-[50px] text-right special-gradient-size large-gradient-heading'>{oosdata.acf.cost_program}</p>
                                                <p className='brand-font text-[16px] text-right'>only</p>
                                            </div>
                                        </div>
                                        <div className='bottom15px'>
                                            <p className='brand-font text-[12px] text-center'>+ taxes as applicable</p>
                                        </div>

                                        <div className='flex h-1/2 justify-center'>
                                            {
                                                (link === "") ?
                                                    <button disabled className='p-4 rounded bg-gray-300' onClick={() => buyNow()}>
                                                        <p className='txt brand-font'>Coming Soon</p>
                                                    </button>
                                                    :
                                                    <button className='p-4 rounded bg-green-500' onClick={() => buyNow()}>
                                                        <p className='txt-inverse small-heading brand-font'>BUY NOW</p>
                                                    </button>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col gap-2'>
                                {
                                    oosdata.acf.highlights_program.map(prog => (
                                        <div className='border-solid border-gray border-[1px] rounded p-2 flex-grow flex items-center'>
                                            <p className='brand-font text-[16px] p-1'>{prog.highlight_program}</p>
                                        </div>
                                    ))
                                }
                            </div>


                        </div>

                        {/* requirements */}
                        <div className='spacer'>
                            <p className='brand-text bottom7px txt-heading-large'>Requirements :</p>
                            <ul>
                                {
                                    oosdata.acf.requirements_program.map(prog => (
                                        <li className='brand-text txt py-1'>✨ {prog.requirement_program}</li>
                                    ))
                                }
                            </ul>
                        </div>

                        {/* contents */}
                        <div className='spacer'>
                            <p className='brand-text bottom7px txt-heading-large'>What do you get ?</p>
                            <ul>
                                {
                                    oosdata.acf.contents_program.map(prog => (
                                        <li className='brand-text txt py-1'>✨ {prog.content_program}</li>
                                    ))
                                }
                            </ul>
                        </div>

                        {/* objectives */}
                        <div className='spacer'>
                            <p className='brand-text bottom7px txt-heading-large'>Program Objectives :</p>
                            <ul>
                                {
                                    oosdata.acf.objectives_program.map(prog => (
                                        <li className='brand-text txt py-1'>✨ {prog.objective_program}</li>
                                    ))
                                }
                            </ul>
                        </div>

                    </>
            }
        </div>
    )
}

export default OneonOneSession